// lint rule not applicable to V2 components
/* eslint-disable */
import CloseIcon from '@mui/icons-material/Close';
import Drawer from '@mui/material/Drawer';

import { MenuItem } from '@mui/material';
import router from 'next/router';
import React from 'react';
import { HeaderContent } from '../../../contentful';
import SunrunLogo from '../../../public/cmsAssets/assets/img/logo/TextLogo';
import { brandColors } from '../../../styles/sunrunTheme.styles';
import { trackEvents } from '../../../utils/analytics';
import useStyles from './Navigation.styles';

interface Props {
  open: boolean;
  onClose: () => void;
  content?: HeaderContent;
}

/**
 * @deprecated V2 component
 */
export default function Navigation({
  open,
  onClose,
  content,
}: Props): React.JSX.Element {
  const { classes } = useStyles();

  return (
    <Drawer
      anchor={'top'}
      open={open}
      onClose={onClose}
      classes={{ paper: classes.drawer }}
      transitionDuration={400}
      ModalProps={{
        keepMounted: true,
      }}
    >
      <div className='sidebarWrapper'>
        <div className='sidemenuWrapper'>
          <div className='headerElementsWrapper'>
            <SunrunLogo
              width='110'
              color={brandColors.primaryMain}
              classname={classes.logo}
            />
            <button
              className={classes.closeIcon}
              onClick={onClose}
              aria-label='Close'
            >
              <CloseIcon />
            </button>
          </div>
          <div className='sidebarMenu'>
            {content?.fields?.categories.map((category) => (
              <div
                className={`${classes.menuItem} ${classes.item}`}
                key={category.sys.id}
              >
                <div>
                  {category.fields.name}
                  {category.fields.links.map((link) => (
                    <MenuItem
                      key={link.sys.id}
                      onClick={() => {
                        trackEvents({
                          event: 'Hamburger click',
                          click_text: link.fields.text,
                        });
                        setTimeout(onClose, 1500);
                        router.push(link.fields.url);
                      }}
                    >
                      {link.fields.text}
                    </MenuItem>
                  ))}
                </div>
              </div>
            ))}
            <a href='/free-solar-quote'>
              <p className='sidebarMenu-element'>Get a Quote</p>
            </a>
          </div>
        </div>
      </div>
    </Drawer>
  );
}
